import React, { useEffect } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router-dom";
import { INTEGRATION_HUB } from "../../constants/routes";

export default function FacebookConnected() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate(INTEGRATION_HUB), 2500);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 64, color: "success.main" }} />
      <Typography variant="h5" fontWeight={700}>
        Facebook Connected!
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Your pages have been saved. Redirecting to Integration Hub…
      </Typography>
      <CircularProgress size={24} sx={{ mt: 1 }} />
    </Box>
  );
}
